import React, { useState, useEffect, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux'
import ContactHeading from './ContactHeading';
import ContactTables from './ContactTables';
import SidebarContact from './Sidebar/SidebarContact';
import { getRequest } from '../../helpers/apiHandler';

const Contact = () => {
  const dispatch = useDispatch();
  const { access_token } = useSelector((state) => state.auth.user)
  const { reload_contact_list, reload_contact_overview } = useSelector((state) => state.contacts)

  const [onLoading, setOnLoading] = useState(false);
  const [contactList, setContactList] = useState([]);
  const [contactData, setContactData] = useState([]);
  const [allTags, setAllTags] = useState([]);
  const [searchTags, setSearchTags] = useState([]);
  const [leadListId, setLeadListId] = useState('');
  const [searchQuery, setSearchQuery] = useState('');
  const isFirstRun = useRef(true);

  const getContactList = () => {
    setOnLoading(true);
    const data = {
      headers: { Authorization: access_token.token },
    };
    getRequest('/v2/contacts-list', data, (res) => {
      if (res.success) {
        const { data } = res;
        setContactList(data.contact_list);
      }
      setOnLoading(false);
    });
  };

  const getContactsOverview = params => {
    const { tags, lead_list_id } = params;

    const data = {
      headers: { Authorization: access_token.token },
      params: { date_range: '', tags: tags, lead_list_id: lead_list_id },
    };
    getRequest('/v2/contacts-overview', data, res => {
      if (res.success) {
        const { data } = res;
        setContactData(data.data);
        setAllTags(data.all_tags);
      }
    });
  };

  useEffect(() => {
    getContactsOverview({ lead_list_id: leadListId, tags: searchTags });
    getContactList();
  }, [leadListId]);


  useEffect(() => {

    if (isFirstRun.current) {
      isFirstRun.current = false;
      return;
    }
    getContactList();
  }, [reload_contact_list]);

  useEffect(() => {
    if (isFirstRun.current) {
      isFirstRun.current = false;
      return;
    }
    getContactsOverview({ lead_list_id: leadListId });
  }, [reload_contact_overview]);

  const handleSearch = event => {
    setSearchQuery(event);
  };

  const filteredContacts = contactData.filter(contact => {
    const searchLowerCase = searchQuery.toLowerCase();
    if (contact.phone.includes(searchLowerCase)) {
      return true;
    }

    if (contact.tags && contact.tags.some(tag => tag.includes(searchLowerCase))) {
      return true;
    }

    if (contact.custom_field && Object.keys(contact.custom_field).length > 0) {
      return Object.values(contact.custom_field).some(
        value => typeof value === 'string' && value.toLowerCase().includes(searchLowerCase)
      );
    }
    return false;
  });

  return (
    <div className="Contact">
      <SidebarContact
        contactList={contactList}
        setLeadListId={setLeadListId}
        setSearchTags={setSearchTags}
        allTags={allTags}
        contactData={contactData}
      />
      <div style={{ width: '100%' }}>
        <ContactHeading
          contactData={contactData}
          contactList={contactList}
          allTags={allTags}
          setSearchQuery={handleSearch}
        />
        <ContactTables
          contactData={filteredContacts}
          setContactData={setContactData}
          allTags={allTags}
          setLeadListId={setLeadListId}
        />
      </div>
    </div>
  );
};

export default Contact
